export default {
  weekNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthNames: [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ],
  titleFormat: 'MMMM'
}



// WEBPACK FOOTER //
// ./src/components/Month/langSets.js